import SettingsOutlinedIcon from '@mui/icons-material/SettingsOutlined';

import { roleManager, roleViewer } from '@/router/consts';

import { 매니저_라우터 } from '.';
import type { SidebarMenu } from '../types';
import { 공지사항_라우트_리스트 } from './notice-setting/공지사항_라우터';
import { 영업_라우트_리스트 } from './영업/영업_라우터';

// 매니저 계정 사이드바 메뉴
const ManagerMenus: SidebarMenu[] = [
  {
    title: 매니저_라우터['shop-list'].handle.title,
    path: 매니저_라우터['shop-list'].path,
    icon: <SettingsOutlinedIcon />,
    roles: [roleManager, roleViewer],
  },
  {
    title: 매니저_라우터['create-coupon'].handle.title,
    path: 매니저_라우터['create-coupon'].path,
    icon: <SettingsOutlinedIcon />,
    roles: [roleManager, roleViewer],
  },
  {
    title: 매니저_라우터['credit'].handle.title,
    path: 매니저_라우터['credit'].path,
    icon: <SettingsOutlinedIcon />,
    roles: [roleManager, roleViewer],
  },
  {
    title: 매니저_라우터['maintenance-setting'].handle.title,
    path: 매니저_라우터['maintenance-setting'].path,
    icon: <SettingsOutlinedIcon />,
    roles: [roleManager, roleViewer],
  },

  {
    title: 매니저_라우터['market-items-management'].handle.title,
    path: 매니저_라우터['market-items-management'].path,
    icon: <SettingsOutlinedIcon />,
    roles: [roleManager, roleViewer],
  },
  {
    title: '공지사항 게시',
    path: '__공지사항',
    icon: <SettingsOutlinedIcon />,
    roles: [roleManager, roleViewer],
    childrenMenus: 공지사항_라우트_리스트
      .filter(v => v.handle?.displayInSidebarMenu)
      .map((v): SidebarMenu => {
        return {
          title: v.handle?.title ?? '제목 없음',
          path: v.path,
          display: true,
        };
      }),
  },
  //영업 매니저
  {
    title: '영업',
    path: '__영업',
    icon: <SettingsOutlinedIcon />,
    roles: [roleManager, roleViewer],
    childrenMenus: 영업_라우트_리스트
      .filter(v => v.handle?.displayInSidebarMenu)
      .map((v): SidebarMenu => {
        return {
          title: v.handle?.title ?? '제목 없음',
          path: v.path,
          display: true,
        };
      }),
  },
  {
    title: 매니저_라우터['consistency-report'].handle.title,
    path: 매니저_라우터['consistency-report'].path,
    icon: <SettingsOutlinedIcon />,
    roles: [roleManager, roleViewer],
  },

  {
    title: 매니저_라우터['item-force-update'].handle.title,
    path: 매니저_라우터['item-force-update'].path,
    icon: <SettingsOutlinedIcon />,
    roles: [roleManager, roleViewer],
  },

  {
    title: 매니저_라우터['원스톱_솔루션_비용납부_확인'].handle.title,
    path: 매니저_라우터['원스톱_솔루션_비용납부_확인'].path,
    icon: <SettingsOutlinedIcon />,
    roles: [roleManager, roleViewer],
  },

  {
    title: 매니저_라우터['네이버_시크릿키_수정'].handle.title,
    path: 매니저_라우터['네이버_시크릿키_수정'].path,
    icon: <SettingsOutlinedIcon />,
    roles: [roleManager, roleViewer],
  },
];

export default ManagerMenus;
